import { Divider, Drawer, Space, Button, Slider, TreeSelect, Checkbox } from "antd";
import React from "react";
import moment from "moment";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { apiCall } from "../../../utils/Api";
import { usePrefs } from "../../../utils/Prefs";

export default function Footer(props) {

    const [prefs, setPrefs] = usePrefs();
    const { edit = false, close = () => { }, menus = [] } = props;

    // set componenet specific
    const setData = (_data) => {
        setPrefs({ ...prefs, "footer_bar": { ...prefs.footer_bar, "data": _data } })
    }

    // Component agnostic
    const {
        name = "",
        data = {},
        date_changed = 0
    } = prefs.footer_bar;

    // Component specific
    const {
        background_colour = 0,
        text_colour = 0,
        link_colour = 0,
        link_hover_colour = 0,
        width = 1248,
        terms_condition_enabled = false,
        privacy_policy_enabled = false,
        contact_us_menu_id = null,
        font_size = 14,
    } = data;

    // Save all the persistant ui elements
    const save = () => {
        props.saveItem("footer_bar", prefs.footer_bar);
        close();
    }

    const parseMenus = (_privacy = false) => {

        let _menus = [...menus]
        let ret = _menus.filter(item => item.parent_id === null).map(m => {
            return {
                value: m.id,
                title: m.name,
                children: _menus.filter(i => i.parent_id == m.id).map(c => {
                    return {
                        value: c.id,
                        title: c.name,
                        children: []
                    }
                })
            }
        })

        if (_privacy) {
            ret.unshift({
                value: 0,
                title: "Hide Privacy Policy",
                children: []
            })
        } else {
            ret.unshift({
                value: 0,
                title: "Default",
                children: []
            })
        }

        return ret;

    }

    // Re-fetch old and update ui element
    const onCancel = () => {
        apiCall("site_content/getContent", {}, (_status, _result) => {
            if (_status) {
                if (_result) {
                    let _r = _result.find(item => item.component === "footer_bar")
                    if (_r) {
                        setPrefs({ ...prefs, "footer_bar": { ...prefs.footer_bar, "data": _r.data, "container": _r.container } })
                    }
                }
            }
        })
        close();
    }

    const drawForm = () => {
        return (
            <>
                <div style={{ "fontSize": "18px", "lineHeight": "18px" }}><strong>{name}</strong></div>
                {(date_changed && <em style={{ "fontSize": "12px" }}>Last updated {moment(date_changed * 1000).format("MMM Do, YYYY h:mm a")}</em>)}
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "justifyContent": "stretch" }}>
                    <Button onClick={() => save()} block size="small" type="primary"><small>Save Changes</small></Button>
                    <div style={{ "width": "10px" }}></div>
                    <Space>
                        <Button onClick={() => onCancel()} size="small" type="default"><small>Cancel</small></Button>
                    </Space>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WIDTH</Divider>
                <Slider
                    min={400}
                    max={1248}
                    onChange={(_v) => setData({ ...data, "width": _v })}
                    value={width}
                />

                {/* FONT SIZE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FONT SIZE</Divider>
                <Slider defaultValue={font_size} onChange={(e) => setData({ ...data, "font_size": e })} min={10} max={24} />


                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={background_colour} onChange={(e) => setData({ ...data, "background_colour": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={text_colour} onChange={(e) => setData({ ...data, "text_colour": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK / BUTTON COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={link_colour} onChange={(e) => setData({ ...data, "link_colour": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK / BUTTON HOVER COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={link_hover_colour} onChange={(e) => setData({ ...data, "link_hover_colour": e })} />
                <div className="shim" /> <div className="shim" />
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHOW CONTACT US PAGE</Divider>
                <TreeSelect value={(contact_us_menu_id) ? contact_us_menu_id : 0} onChange={(e) => setData({ ...data, "contact_us_menu_id": (e) ? e : null })} style={{ "width": "250px" }} treeData={parseMenus(false)} />
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHOW TERMS & CONDITIONS PAGE</Divider>
                <Checkbox checked={terms_condition_enabled} onChange={(e) => setData({ ...data, "terms_condition_enabled": e.target.checked })} />
                <div className="shim" /> <div className="shim" />


                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHOW PRIVACY POLICY PAGE</Divider>
                <Checkbox checked={privacy_policy_enabled} onChange={(e) => setData({ ...data, "privacy_policy_enabled": e.target.checked })} />
                <div className="shim" /> <div className="shim" />



            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => onCancel(true)} open={edit}>
                {drawForm()}

            </Drawer>
        </>
    )
}